import { gql } from '@urql/core';

export const GET_UNSEEN_NOTIFICATION_COUNT = gql`
  query GetUnseenNotificationCount {
    unseenNotificationCount
  }
`;

export const GET_STAFF_NOTIFICATIONS = gql`
  query GetStaffNotifications($options: StaffNotificationListOptions) {
    staffNotifications(options: $options) {
      items {
        id
        type
        severity
        title
        body
        actionUrl
        metadata
        seenAt
        readAt
        createdAt
      }
      totalCount
    }
  }
`;

export const MARK_NOTIFICATIONS_SEEN = gql`
  mutation MarkNotificationsSeen {
    markNotificationsSeen
  }
`;

export const MARK_NOTIFICATION_READ = gql`
  mutation MarkNotificationRead($id: ID!) {
    markNotificationRead(id: $id)
  }
`;

export const DISMISS_NOTIFICATION = gql`
  mutation DismissNotification($id: ID!) {
    dismissNotification(id: $id)
  }
`;

export const GET_MERCHANT_NOTIFICATION_PREFERENCES = gql`
  query GetMerchantNotificationPreferences {
    merchantNotificationPreferences {
      matrix
      lowStockThreshold
      recipients {
        id
        notificationType
        email
        phone
        label
        isActive
      }
      staffRecipients {
        administratorId
        firstName
        lastName
        emailAddress
        isOwner
        notificationTypes
      }
    }
  }
`;

export const UPDATE_MERCHANT_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateMerchantNotificationPreferences($input: UpdateMerchantNotificationPreferencesInput!) {
    updateMerchantNotificationPreferences(input: $input) {
      matrix
      lowStockThreshold
    }
  }
`;

export const ADD_NOTIFICATION_RECIPIENT = gql`
  mutation AddNotificationRecipient($input: AddNotificationRecipientInput!) {
    addNotificationRecipient(input: $input) {
      id
      notificationType
      email
      phone
      label
      isActive
    }
  }
`;

export const REMOVE_NOTIFICATION_RECIPIENT = gql`
  mutation RemoveNotificationRecipient($id: ID!) {
    removeNotificationRecipient(id: $id)
  }
`;

export const TOGGLE_NOTIFICATION_RECIPIENT = gql`
  mutation ToggleNotificationRecipient($id: ID!, $isActive: Boolean!) {
    toggleNotificationRecipient(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`;

export const UPDATE_STAFF_RECIPIENTS = gql`
  mutation UpdateStaffRecipients($input: UpdateStaffRecipientsInput!) {
    updateStaffRecipients(input: $input) {
      administratorId
      firstName
      lastName
      emailAddress
      isOwner
      notificationTypes
    }
  }
`;
